import { Grid } from "@material-ui/core";
import React from "react";

import { Form } from "../../../../components/form";
import { FormButton } from "../../../../components/form_button";
import { TextInput } from "../../../../components/text_input";
import { IFormProps } from "../../../../core/models";
import { isPending } from "../../../../core/redux";
import { expenseFormValidation, IExpenseForm } from "../../data/entities";

interface IProps extends IFormProps<IExpenseForm> {}

export const ExpenseForm: React.FC<IProps> = (props: IProps) => {
  const { branch, submitTitle } = props;
  const loading = isPending(branch);

  return (
    <Grid container justify="center">
      <Grid item md={8} lg={6}>
        <Form<IExpenseForm>
          {...props}
          initialValues={{
            name: "",
          }}
          validationSchema={expenseFormValidation}
        >
          {() => (
            <>
              <TextInput label="Name" name="name" />

              <FormButton label={submitTitle} loading={loading} />
            </>
          )}
        </Form>
      </Grid>
    </Grid>
  );
};
